import useCatalogDeleteOptions from "@components/Actions/useCatalogDeleteOptions";
import Icon from "@components/Atoms/Icon";
import { catalogDeleteConfirm } from "@ext/catalog/actions/propsEditor/components/catalogDeleteConfirm";
import { useDeleteCatalogFromSpace } from "@ext/catalog/actions/propsEditor/components/useDeleteCatalog";
import t from "@ext/localization/locale/translate";
import type { CatalogLink } from "@ext/navigation/NavigationLinks";
import { CardMenuTrigger } from "@ui-kit/Card";
import { ConfirmMenuItem } from "@ui-kit/ConfirmPopover";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@ui-kit/Dropdown";

const CardNotLoadedActions = ({ catalogLink }: { catalogLink: CatalogLink }) => {
	const { fromSpace } = useCatalogDeleteOptions(catalogLink.name, true);
	const deleteFromSpace = useDeleteCatalogFromSpace({ name: catalogLink.name, repo: catalogLink.repo });

	if (!fromSpace) return null;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
				<CardMenuTrigger aria-label={t("catalog.actions.title")} />
			</DropdownMenuTrigger>
			<DropdownMenuContent align="start">
				<ConfirmMenuItem
					confirm={catalogDeleteConfirm("space-not-loaded")}
					onClick={(e) => e.stopPropagation()}
					onConfirm={deleteFromSpace}
					type="danger"
				>
					<Icon code="trash" />
					{t("catalog.delete.space.name")}
				</ConfirmMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default CardNotLoadedActions;
